/* eslint-disable */
import { CallbackAttributes } from 'kosmos/models';
import {
  CompanyUpdateSubscriptionDto,
  CompanyUpdateSubscriptionDtoQueryResultDto,
  FilterItemDto,
} from 'models/dtoTypes';
import { getOrganisationsApi } from 'services';

export const GetOrganisationCallback = async (
  orgId: string,
  options: {
    pageIndex: number;
    fullTextSearch?: string;
    filters?: FilterItemDto[];
    sortColumn?: string;
    isDesc?: boolean;
  },
): Promise<CompanyUpdateSubscriptionDtoQueryResultDto> => {
  const client = await getOrganisationsApi();
  const response = await client.getCallbacks(orgId, options.pageIndex);
  return response.data;
};
export const CreateOrganisationCallback = async (requestBody: CallbackAttributes &{
  organisationId: string;
}): Promise<CompanyUpdateSubscriptionDto> => {
  const client = await getOrganisationsApi();
  const response = await client.createOrganisationCallback(requestBody.organisationId, requestBody);
  return response.data;
};

export const DeleteOrganisationCallback = async (
  orgId: string,
  callbackId: string,
): Promise<CompanyUpdateSubscriptionDto> => {
  const client = await getOrganisationsApi();
  const response = await client.deleteOrganisationCallback(orgId, callbackId);
  return response.data;
};
